<template>
    <div v-if="page > 0" class="d-flex flex-row">

        <div class="py-1">Wyników na stronie</div>
        <div class="px-2">
            <select v-model="proxySize" class="form-control form-control-sm">
                <option v-for="size in sizeOptions" :key="size" :value="size">
                    {{ size }}
                </option>
            </select>
        </div>
        <div class="px-2 py-1">
            {{ start }} - {{ end }} z {{ total }}
        </div>


        <div class="d-flex flex-row px-2">
            <div class="py-1">Strona</div>
            <div class="px-2" style="width: 100px">
                <form @submit.prevent>
                    <input v-model.lazy="page"
                           class="form-control form-control-sm"
                           :placeholder="page"
                           :disabled="pages === 1"
                           ref="input"
                    />
                </form>
            </div>
            <div class="py-1">z {{ pages || 0 }}</div>
        </div>


        <div class="px-2 py-1">
            <a @click.prevent="previous" class="text-default cursor-default pr-2" :disabled="page === 1">←</a>
            <a @click.prevent="next" class="text-default cursor-default" :disabled="page === pages">→</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        props: {
            value: {},
            total: {},
            pageSize: {},
            disabled: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                proxySize: this.pageSize,
            }
        },

        computed: {
            pages() {
                return Math.ceil(this.total / this.pageSize);
            },

            page: {
                get() {
                    return this.value || 1;
                },

                set(value) {
                    if (this.disabled) {
                        return
                    }
                    if (value > this.pages) {
                        value = this.pages
                    } else if (value <= 0) {
                        value = 1
                    }

                    this.$emit('input', value)
                    this.setInputValue(value)
                }
            },

            start() {
                return (this.value - 1) * this.pageSize + 1
            },

            currentResultsSize() {
                if (this.page < this.pages) {
                    return this.pageSize
                }

                return this.total - (this.pages - 1) * this.pageSize;
             },

            end() {
                return (this.value - 1) * this.pageSize + this.currentResultsSize
            },

            sizeOptions() {
                const options = []

                for (let i = 1; i < 10; i++) {
                    options.push(i * 10)
                }
                for (let i = 1; i < 3; i++) {
                    options.push(i * 100)
                }

                return options
            },
        },

        watch: {
            proxySize(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.$emit('sizeChange', newValue)
                }
            },
        },

        methods: {
            setInputValue(value) {
                if (this.$refs.input) {
                    this.$refs.input.value = value
                }
            },

            next() {
                if (this.disabled) {
                    return
                }

                this.page++
            },

            previous() {
                if (this.disabled) {
                    return
                }

                this.page--
            }
        }
    }
</script>
